import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as SmartyStreetsSDK from 'smartystreets-javascript-sdk';

const SmartyStreetsCore = (SmartyStreetsSDK as any).core;
const Lookup = (SmartyStreetsSDK as any).usAutocompletePro.Lookup;

@Injectable({
  providedIn: 'root'
})
export class SmartyService {

  constructor() { }

  autocompleteAddress(term: string): any {
    const websiteKey = environment.smartyStreetWesiteKey;
    const credentials = new SmartyStreetsCore.SharedCredentials(websiteKey);
    const clientBuilder = new SmartyStreetsCore.ClientBuilder(credentials).withLicenses(['us-autocomplete-pro-cloud']);
    const client = clientBuilder.buildUsAutocompleteProClient();
    const lookup = new Lookup(term);
    return client.send(lookup);
  }
}
